const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

const reveal = (root) => {
  const nodes = root.querySelectorAll('[data-km-reveal]:not(.is-in)');
  if (!nodes.length) return;

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    nodes.forEach((node) => node.classList.add('is-in'));
    return;
  }

  document.documentElement.classList.add('km-motion');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
  );

  nodes.forEach((node) => observer.observe(node));
};

const start = () => reveal(document);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target) reveal(event.target);
});
